import { _ as __assign } from './tslib.es6-86dc5b0c.js';
import { jsx } from 'react/jsx-runtime';

/**
 * Custom renderer for links that adds `target="_parent"` and `rel="noopener noreferrer"`
 */
var MarkdownLinkRenderer = function (_a) {
    var children = _a.children, href = _a.href;
    return (jsx("a", __assign({ href: href, rel: "noopener noreferrer", target: "_parent" }, { children: children }), void 0));
};

export { MarkdownLinkRenderer as M };
